<template>
    <svg viewBox="0 0 21 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.57506 8.83305H2.17969V7.14853L5.7593 5.59561L8.07552 0.568359H10.0496V6.27995H18.2616V8.83305H10.0496V23.0462C10.0496 24.4851 10.1636 25.6169 10.3917 26.4416C10.6374 27.3014 11.0849 27.9331 11.7341 28.3367C12.3833 28.7227 13.3133 28.9157 14.5241 28.9157C15.6822 28.9157 16.928 28.7754 18.2616 28.4946V30.495C15.805 31.2846 13.4449 31.6794 11.1814 31.6794C9.7074 31.6794 8.57561 31.4952 7.78599 31.1267C6.96128 30.7406 6.391 30.1704 6.07515 29.4158C5.74175 28.6262 5.57506 27.5646 5.57506 26.231V8.83305Z" fill="currentColor"/>
        <path d="M0.164062 14.3388C0.164062 13.7806 0.616575 13.3281 1.17478 13.3281H19.3676C19.9258 13.3281 20.3783 13.7806 20.3783 14.3388C20.3783 14.897 19.9258 15.3496 19.3676 15.3496H1.17478C0.616575 15.3496 0.164062 14.897 0.164062 14.3388Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'IconTims'
}
</script>